import { Outlet } from 'react-router-dom';

// ==============================|| COMMON LAYOUT ||============================== //
//
// The chrome-free layout the login and OAuth callback screens render into. The template shipped a
// landing page and a component browser here too; neither survived into the dashboard.

const CommonLayout = () => <Outlet />;

export default CommonLayout;
